var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96875 8.1875C6.80208 8.1875 6.64083 8.15625 6.485 8.09375C6.32833 8.03125 6.19792 7.94792 6.09375 7.84375L0.34375 2.09375C0.114583 1.86458 0 1.57292 0 1.21875C0 0.864583 0.114583 0.572916 0.34375 0.34375C0.572916 0.114583 0.864583 0 1.21875 0C1.57292 0 1.86458 0.114583 2.09375 0.34375L6.96875 5.21875L11.8437 0.34375C12.0729 0.114583 12.3646 0 12.7188 0C13.0729 0 13.3646 0.114583 13.5937 0.34375C13.8229 0.572916 13.9375 0.864583 13.9375 1.21875C13.9375 1.57292 13.8229 1.86458 13.5937 2.09375L7.84375 7.84375C7.71875 7.96875 7.58333 8.05708 7.4375 8.10875C7.29167 8.16125 7.13542 8.1875 6.96875 8.1875Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.d4124a4b87a108fa5f04097f56ed21bc.svg";
export { ForwardRef as ReactComponent };